export default function Stamp({ size = 150, dark = false }) {
  const ring = dark ? '#E5A83B' : '#C84B27';
  return (
    <div
      data-testid="heritage-stamp"
      className="stamp-spin shrink-0"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 120 120" width={size} height={size}>
        <defs>
          <path id="stamp-circle" d="M 60,60 m -44,0 a 44,44 0 1,1 88,0 a 44,44 0 1,1 -88,0" />
        </defs>
        <circle cx="60" cy="60" r="58" fill="none" stroke={ring} strokeWidth="2.5" />
        <circle cx="60" cy="60" r="52" fill="none" stroke={ring} strokeWidth="1" strokeDasharray="3 4" />
        <circle cx="60" cy="60" r="30" fill="none" stroke={ring} strokeWidth="1.5" />
        <text fill={ring} fontSize="10.5" fontFamily="'IBM Plex Mono', monospace" letterSpacing="2.5">
          <textPath href="#stamp-circle">AYAM GORENG WIDURAN • SOLO • SEJAK 1973 •</textPath>
        </text>
        <text
          x="60"
          y="67"
          textAnchor="middle"
          fill={ring}
          fontSize="20"
          fontWeight="700"
          fontFamily="'Cormorant Garamond', serif"
        >
          1973
        </text>
      </svg>
    </div>
  );
}
